/*@ngInject*/
const KeepAliveRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.keepAlive = function (requestTimeout) {
        const url = '/rest/Session';
        const config = {
            timeout: requestTimeout
        };

        return this.get(url, config);
    };
};

angular.module('umCore')
    .service('keepAliveRepository', KeepAliveRepository);
